const QueryStrings = {
    SOURCE: 'source',
    CLIENT_GATEWAY_UUID: 'clientGatewayUuid',
    CLIENT_GATEWAY: 'clientGateway',
    ORGANIZATION_UUID: 'organizationUuid',
    PLAYBOOK_UUID: 'playbookUuid',

    //landing pages
    LANDING_PAGE_UUID: 'landingPageUuid',
    BRANDED_LOGIN: 'brandedLogin',
    PROJECT_TYPE: 'type',
    PROPERTY_SEARCH_ACTION: 'propertySearchAction',
    PROPERTY_UUID: 'propertyUuid',
    PROPERTY_SEARCH_FILTER: 'propertySearchFilter',
    HOH_ADDRESS: 'hohAddress',
};
export default QueryStrings;
